import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Col, Row, Tabs} from "antd";
import {UserOutlined} from "@ant-design/icons";

import StaffActions from "./actions/StaffActions";
import JailMemberRestrictions from "../jail/JailMemberRestrictions";
import Comments from "../Comments";
import {getAccountMembershipNumber, getActiveAccount} from "../../../lib/activeMember";
import AccountDetailsCardStaff from "../../../components/account/AccountDetailsCardStaff";
import AccountAdditionalDetails from "../../../components/account/AccountAdditionalDetails";
import AccountDriverManagementTable from "../../../components/account/AccountDriverManagementTable";
import ErrorBoundary from "../../../components/ErrorBoundary";
import PageTitle from "../../../components/page/PageTitle";

import {cardsGridColumn} from "../../../assets/styles";

const AccountInfoStaff = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [activeKey, setActiveKey] = useState(1);

    useEffect(() => {
        // When staff did not set membership, display link to account change page
        if (getAccountMembershipNumber() == null || getActiveAccount() == null) {
            navigate('/member_change');
        }
    }, [navigate]);

    useEffect(() => {
        if (location.state) {
            setActiveKey(parseInt(location.state.activeKey));
        }
    }, [location.state]);

    const account = getActiveAccount();
    const accountID = account == null ? 0 : account.id;

    const tabsItems = [
        {
            label: 'General Information',
            key: 1,
            children:
                <ErrorBoundary>
                    <Row gutter={{sm: 16}}>
                        <Col {...cardsGridColumn}>
                            <AccountDetailsCardStaff/>
                        </Col>
                        <Col {...cardsGridColumn}>
                            <AccountAdditionalDetails/>
                        </Col>
                    </Row>
                    <AccountDriverManagementTable/>
                </ErrorBoundary>
        },
        {
            label: 'Staff Actions',
            key: 2,
            children:
                <ErrorBoundary>
                    <StaffActions/>
                </ErrorBoundary>
        },
        {
            label: 'Restrictions',
            key: 3,
            children:
                <ErrorBoundary>
                    <JailMemberRestrictions/>
                </ErrorBoundary>
        },
        {
            label: 'Comments',
            key: 4,
            children:
                <ErrorBoundary>
                    <Comments
                        commentableType="App\Models\Accounts\Account"
                        commentableID={accountID}
                    />
                </ErrorBoundary>
        }
    ];

    return (
        account !== null &&
        <>
            <PageTitle title="Account Info" icon={<UserOutlined/>}/>
            <Tabs
                activeKey={activeKey}
                onChange={(key) => setActiveKey(key)}
                items={tabsItems}
            />
        </>
    )
}

export default AccountInfoStaff;
